// src/pages/Freshers.js
import React from 'react';
import ButtonLink from '../components/Button';

const Freshers = () => {
  return (
    <div className="page freshers-page">
      <section className="page-header">
        <div className="container">
          <h1>Freshers</h1>
          <p>Welcome to Kumpula!</p>
        </div>
      </section>

      <section className="content-section">
        <div className="container">

          <div className="info-card mb-2">
            <h3>Hello there, freshers!</h3>
            <p>
              Welcome to Kumpula! We are Integralis ry, the student organization for all international students in Kumpula
               and the main student organization for the Bachelor’s Programme in Science. Our goal is to help you have an amazing time
              at the University of Helsinki and support you in both your studies and well-being.
            </p>
            <p>
              If you have questions before or during your studies, you can always email us at{' '}
              <a href="mailto:integralis@helsinki.fi">integralis@helsinki.fi</a> or contact board
              members via Telegram (see the "Integralis/Association and representatives" page for contacts).
            </p>

            <p className="documents-item">
                <ButtonLink href="https://cdn.jsdelivr.net/gh/integralis-ry/site_binaries/documents/Fresher_guide.pdf">
                  Fresher's guide (pdf)
                </ButtonLink>
              </p>
          </div>

          <div className="info-card mb-2">
            <h3>Studies</h3>
            <p>
              Courses are selected and registered in SISU, the University of Helsinki study portal.
              During orientation your tutors and the faculty will show you how it works, so you
              don’t need to master it in advance.
            </p>
            <p>
              For the Bachelor’s programme in science, everyone follows the same compulsory core courses regardless
              of study track for the first two periods. You can add more courses later, but it is usually best to first get a
              feel for workload and pace. The Integralis studies committee publishes study guides for each module on our <a href='https://t.me/Integralishub'>Telegram</a>.
            </p>
            <p>
              If you run into problems with your studies, you can always contact your tutors,
              Integralis’ study officers, or the degree programme’s study coordinator for support.
            </p>
          </div>

          <div className="info-card mb-2">
            <h3>Where to study</h3>
            <p>
              There are many good places to study: the Kumpula campus library, the main library in
              Kaisa House, and city libraries such as Oodi. You can also book group work rooms
              through Outlook with your university account.
            </p>
            <p>
              Integralis’ student room, <strong>Hideout</strong> (Exactum C131), is perfect for
              casual studying, hanging out and meeting other students. There are snacks and coffee,
              and often a board member around if you need help or just want to chat.
            </p>
          </div>

          <div className="info-card mb-2">
            <h3>Student organisations & overalls</h3>
            <p>
              Kumpula has many subject-specific student organisations: HYK (chemistry), Matrix
              (mathematics), Resonanssi (physics), TKO-äly (computer science), and many more. Most
              welcome members from other programmes, and membership is usually just a few euros per
              year.
            </p>
            <p>
              Each organisation has its own coloured student overalls that are worn at many events.
              Integralis has sky blue overalls with a band on the leg indicating the study track.
              These overalls are decorated with patches and collecting patches from events is a big part of the fun.
            </p>
          </div>

          <div className="info-card">
            <h3>Events & tips</h3>
            <p>
              During orientation week and the autumn there will be plenty of events: tutor group
              activities, picnics, parties, fresher orienteering/adventure in the city centre, and
              the traditional Fresher Sitsit (academic table party). These are great chances to meet
              your fellow freshers and older students.
            </p>
            <p>
              If everything feels overwhelming – or if you feel like you don’t have enough
              information – remember one of our favourite tips: <strong>DWAI – Don’t Worry About
              It</strong>. You’re not alone in figuring things out, and you can always talk to your
              tutors, the faculty or us on the board.
            </p>
          </div>

        </div>
      </section>
    </div>
  );
};

export default Freshers;
